import React from 'react';
import { Countdown } from './Shared';
export const UrgencySection = () => {
  return <section id="precio-lanzamiento" className="bg-familia-bg border-t border-familia-electric/30 py-5 md:py-8 px-4 md:px-6" data-id="element-255">
      <div className="max-w-2xl mx-auto text-center w-[92%] md:w-full" data-id="element-256">
        <h2 className="text-familia-red font-bold text-xs sm:text-sm md:text-base mb-3 md:mb-5 animate-blink uppercase tracking-widest text-center" data-id="element-257">
          ⏰ EL PRECIO PROMOCIONAL TERMINA EN:
        </h2>
        <Countdown className="mb-3 md:mb-5 scale-75 md:scale-90 origin-top" data-id="element-258" />
        <p className="text-familia-gray text-[11px] sm:text-xs md:text-sm mb-4 md:mb-6 text-center font-medium" data-id="element-259">
          Cuando termine esta promoción, el precio puede aumentar y los bonos
          pueden dejar de estar incluidos.
        </p>
        <div className="max-w-sm mx-auto bg-familia-card border border-familia-red/20 p-2 md:p-3 rounded-xl" data-id="element-260">
          <div className="flex justify-between items-center mb-2" data-id="element-261">
            <div className="flex items-center gap-2" data-id="element-262">
              <span className="w-1.5 h-1.5 bg-familia-red rounded-full animate-ping" data-id="element-263" />
              <span className="text-[9px] sm:text-[10px] font-bold text-white" data-id="element-264">
                Cupos disponibles al precio promocional
              </span>
            </div>
            <span className="text-familia-red font-bold text-[9px] sm:text-[10px]" data-id="element-265">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-white/5 h-1.5 rounded-full overflow-hidden" data-id="element-266">
            <div className="bg-familia-red h-full w-[15%]" data-id="element-267" />
          </div>
        </div>
      </div>
    </section>;
};